import { useState } from 'react';
import DB from '../data/mockData';

function SettingGroup({ title, ico, items: initialItems, icoBg, icoColor }) {
  const [items, setItems] = useState(initialItems);

  const toggle = (key) => {
    setItems(prev => prev.map(item => item.key === key ? { ...item, on: !item.on } : item));
  };

  return (
    <div className="card">
      <div className="ch">
        <div className="ch-ico" style={icoBg ? { background: icoBg, color: icoColor } : {}}>{ico}</div>
        <div><div className="ch-title">{title}</div></div>
      </div>
      <div className="cb">
        {items.map((item, i) => (
          <div key={item.key} className="d-flex align-items-center justify-content-between py-3" style={i < items.length - 1 ? { borderBottom: '1px solid var(--brd2)' } : {}}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)' }}>{item.label}</div>
              <div style={{ fontSize: 11, color: 'var(--t3)', marginTop: 2 }}>{item.sub}</div>
            </div>
            <div
              className="toggle-switch"
              onClick={() => toggle(item.key)}
              style={{
                width: 40, height: 22, borderRadius: 20,
                background: item.on ? 'var(--teal)' : 'var(--brd)',
                position: 'relative', cursor: 'pointer', transition: 'background .2s', flexShrink: 0
              }}
            >
              <div style={{
                position: 'absolute', width: 16, height: 16, borderRadius: '50%', background: '#fff',
                top: 3, left: item.on ? 21 : 3, transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)'
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Settings() {
  return (
    <div className="content">
      <div className="row g-3">
        <div className="col-lg-6 d-flex flex-column gap-3">
          <SettingGroup title="Notification Preferences" ico="🔔" items={DB.settings.notif} />
          <SettingGroup title="Nova AI Settings" ico="✦" items={DB.settings.nova} icoBg="var(--purple2)" icoColor="var(--purple)" />
        </div>
        <div className="col-lg-6 d-flex flex-column gap-3">
          <SettingGroup title="Data Source Connections" ico="📡" items={DB.settings.data} />
          <SettingGroup title="Display Preferences" ico="🌍" items={DB.settings.display} />
        </div>
      </div>
    </div>
  );
}
